/*
 * Seelbach's Back in Stock signup form (back-in-stock DEV-PLAN "Signup").
 * Replaces AMP's popup. Loaded only when the theme setting bis_form_enabled is
 * on (snippets/bis-form.liquid renders the config + this script).
 *
 * Binds the EXISTING triggers with one delegated listener; ids are not renamed
 * (the PDP script, CSS and tests pin them):
 *   #BIS_trigger, #floating-BIS_trigger   variant from data-bis-id
 *   .BIS_trigger[data-variant-id]          variant from data-variant-id (advent)
 * Product id: data-bis-product-id, data-product-id, else /products/<handle>.js.
 *
 * The listener runs on window in the capture phase and stops the click there,
 * so AMP's script (still installed until uninstall) cannot open its popup too.
 * Triggers never carry .add-to-cart-btn, and a disabled button fires no click,
 * so add to cart and the limit-N locks are untouched.
 *
 * POSTs JSON to <endpoint>/signup with Turnstile (script loaded on first open)
 * and a honeypot; shows the server's message (created / duplicate / suppressed
 * / error).
 */
(function () {
  'use strict';
  if (window.SeelbachsBIS) return;

  var TRIGGERS = '#BIS_trigger, #floating-BIS_trigger, .BIS_trigger[data-variant-id]';
  var TURNSTILE_SRC = 'https://challenges.cloudflare.com/turnstile/v0/api.js?render=explicit';
  var DEFAULT_ENDPOINT = 'https://bis.seelbachs.com';
  var GENERIC_ERROR = 'Something went wrong. Please try again.';
  var INVALID_EMAIL = 'Please enter a valid email address.';
  var TOKEN_WAIT_MS = 15000;

  function readConfig() {
    var el = document.getElementById('bis-form-config');
    if (!el) return null;
    try { var c = JSON.parse(el.textContent || '{}'); return c && typeof c === 'object' ? c : null; } catch (e) { return null; }
  }

  var config = readConfig();
  if (!config) return;

  function signupUrl() {
    var base = String(config.endpoint || '').trim() || DEFAULT_ENDPOINT;
    base = base.replace(/\/+$/, '');
    return /\/signup$/.test(base) ? base : base + '/signup';
  }

  function idOf(value) {
    var s = value == null ? '' : String(value).trim();
    var m = /^(?:gid:\/\/shopify\/\w+\/)?(\d{1,20})$/.exec(s);
    return m ? m[1] : null;
  }

  function validEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value);
  }

  // ---- trigger reading ---------------------------------------------------

  function hiddenProduct(productId) {
    if (!productId) return false;
    return !!document.querySelector('[data-bis-hidden-product="' + productId + '"]');
  }

  function readTrigger(el) {
    var variantId = idOf(el.getAttribute('data-bis-id')) || idOf(el.getAttribute('data-variant-id'));
    var productId = idOf(el.getAttribute('data-bis-product-id')) || idOf(el.getAttribute('data-product-id'));
    var handle = el.getAttribute('data-product-handle') || '';
    return {el: el, variantId: variantId, productId: productId, handle: handle};
  }

  function triggerFrom(target) {
    if (!target || typeof target.closest !== 'function') return null;
    var el = target.closest(TRIGGERS);
    if (!el || el.disabled || el.getAttribute('aria-disabled') === 'true') return null;
    return el;
  }

  var productIdCache = {};
  function resolveProductId(info) {
    if (info.productId) return Promise.resolve(info.productId);
    var handle = info.handle;
    if (!/^[a-z0-9][a-z0-9-]*$/i.test(handle)) return Promise.resolve(null);
    if (!productIdCache[handle]) {
      productIdCache[handle] = fetch('/products/' + handle + '.js', {headers: {Accept: 'application/json'}})
        .then(function (res) { if (!res.ok) throw new Error('product ' + res.status); return res.json(); })
        .then(function (data) { return idOf(data && data.id); })
        .catch(function () { delete productIdCache[handle]; return null; });
    }
    return productIdCache[handle];
  }

  // ---- Turnstile ---------------------------------------------------------

  var turnstileLoad = null;
  var widgetId = null;
  var token = null;
  var tokenWaiters = [];

  function setToken(value) {
    token = value || null;
    if (token) { var w = tokenWaiters; tokenWaiters = []; w.forEach(function (fn) { fn(token); }); }
  }

  function loadTurnstile() {
    if (!config.siteKey) return Promise.resolve(null);
    if (window.turnstile) return Promise.resolve(window.turnstile);
    if (!turnstileLoad) {
      turnstileLoad = new Promise(function (resolve) {
        var s = document.createElement('script');
        s.src = TURNSTILE_SRC;
        s.async = true;
        s.onload = function () { resolve(window.turnstile || null); };
        s.onerror = function () { turnstileLoad = null; resolve(null); };
        document.head.appendChild(s);
      });
    }
    return turnstileLoad;
  }

  function ensureWidget() {
    return loadTurnstile().then(function (ts) {
      if (!ts || widgetId !== null) return;
      try {
        widgetId = ts.render(ui.turnstile, {
          sitekey: config.siteKey,
          appearance: 'interaction-only',
          callback: setToken,
          'expired-callback': function () { setToken(null); },
          'error-callback': function () { setToken(null); }
        });
      } catch (e) { widgetId = null; }
    });
  }

  function waitForToken() {
    if (!config.siteKey) return Promise.resolve(null);
    if (token) return Promise.resolve(token);
    return ensureWidget().then(function () {
      if (token || widgetId === null) return token;
      return new Promise(function (resolve) {
        var done = false;
        var finish = function (value) { if (!done) { done = true; resolve(value); } };
        tokenWaiters.push(finish);
        setTimeout(function () { finish(token); }, TOKEN_WAIT_MS);
      });
    });
  }

  function resetTurnstile() {
    token = null;
    try { if (window.turnstile && widgetId !== null) window.turnstile.reset(widgetId); } catch (e) {}
  }

  // ---- modal -------------------------------------------------------------

  var ui = null;
  var current = null;
  var returnFocus = null;
  var busy = false;

  function build() {
    var root = document.createElement('div');
    root.className = 'bis-modal';
    root.hidden = true;
    root.innerHTML =
      '<div class="bis-modal__backdrop" data-bis-close></div>' +
      '<div class="bis-modal__dialog" role="dialog" aria-modal="true" aria-labelledby="bis-modal-title" aria-describedby="bis-modal-desc" tabindex="-1">' +
        '<button type="button" class="bis-modal__close" aria-label="Close" data-bis-close>' +
          '<svg aria-hidden="true" focusable="false" viewBox="0 0 24 24" width="20" height="20"><path d="M6 6l12 12M18 6L6 18" stroke="currentColor" stroke-width="2" stroke-linecap="round"/></svg>' +
        '</button>' +
        '<h2 class="bis-modal__title" id="bis-modal-title">Get on the List</h2>' +
        '<p class="bis-modal__desc" id="bis-modal-desc"></p>' +
        '<form class="bis-modal__form" novalidate>' +
          '<label class="bis-modal__label" for="bis-email">Email</label>' +
          '<input class="bis-modal__input" id="bis-email" name="email" type="email" autocomplete="email" inputmode="email" required aria-describedby="bis-modal-msg">' +
          '<label class="bis-modal__check"><input type="checkbox" name="accepts_marketing"> <span>Add me to the store mailing list</span></label>' +
          '<div class="bis-modal__hp" aria-hidden="true"><label>Website <input type="text" name="website" tabindex="-1" autocomplete="off"></label></div>' +
          '<div class="bis-modal__turnstile"></div>' +
          '<p class="bis-modal__msg" id="bis-modal-msg" role="status" aria-live="polite"></p>' +
          '<button type="submit" class="bis-modal__submit">Notify Me</button>' +
        '</form>' +
        '<div class="bis-modal__done" hidden>' +
          '<p class="bis-modal__msg bis-modal__msg--success" role="status" aria-live="polite"></p>' +
          '<button type="button" class="bis-modal__submit" data-bis-close>Done</button>' +
        '</div>' +
      '</div>';
    document.body.appendChild(root);
    ui = {
      root: root,
      dialog: root.querySelector('.bis-modal__dialog'),
      desc: root.querySelector('.bis-modal__desc'),
      form: root.querySelector('form'),
      email: root.querySelector('input[name="email"]'),
      marketing: root.querySelector('input[name="accepts_marketing"]'),
      website: root.querySelector('input[name="website"]'),
      turnstile: root.querySelector('.bis-modal__turnstile'),
      msg: root.querySelector('#bis-modal-msg'),
      submit: root.querySelector('form .bis-modal__submit'),
      done: root.querySelector('.bis-modal__done'),
      doneMsg: root.querySelector('.bis-modal__done .bis-modal__msg')
    };
    root.addEventListener('click', function (e) {
      if (e.target.closest('[data-bis-close]')) close();
    });
    root.addEventListener('keydown', onKeydown);
    ui.form.addEventListener('submit', onSubmit);
  }

  function focusables() {
    return Array.prototype.filter.call(
      ui.dialog.querySelectorAll('button, input, select, textarea, a[href], iframe, [tabindex]:not([tabindex="-1"])'),
      function (el) { return !el.disabled && el.tabIndex !== -1 && el.getClientRects().length > 0; }
    );
  }

  function onKeydown(e) {
    if (e.key === 'Escape' || e.key === 'Esc') { e.preventDefault(); close(); return; }
    if (e.key !== 'Tab') return;
    var list = focusables();
    if (list.length === 0) { e.preventDefault(); ui.dialog.focus(); return; }
    var first = list[0], last = list[list.length - 1];
    var active = document.activeElement;
    if (e.shiftKey && (active === first || active === ui.dialog)) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && active === last) { e.preventDefault(); first.focus(); }
  }

  function setMessage(text, kind) {
    ui.msg.textContent = text || '';
    ui.msg.className = 'bis-modal__msg' + (kind ? ' bis-modal__msg--' + kind : '');
  }

  function open(info) {
    if (!info || !info.variantId) return false;
    if (hiddenProduct(info.productId)) return false;
    if (!ui) build();
    current = info;
    returnFocus = info.el || document.activeElement;
    busy = false;
    var title = info.productId && String(config.productId || '') === String(info.productId) ? config.productTitle : '';
    ui.desc.textContent = title
      ? "We'll email you as soon as " + title + ' is available.'
      : "We'll email you as soon as it's available.";
    ui.form.hidden = false;
    ui.done.hidden = true;
    ui.submit.disabled = false;
    ui.email.removeAttribute('aria-invalid');
    if (!ui.email.value && config.email) ui.email.value = config.email;
    ui.website.value = '';
    setMessage('');
    ui.root.hidden = false;
    document.documentElement.classList.add('bis-modal-open');
    ui.email.focus();
    if (config.siteKey) ensureWidget();
    if (!info.productId && info.handle) resolveProductId(info);
    return true;
  }

  function close() {
    if (!ui || ui.root.hidden) return;
    ui.root.hidden = true;
    document.documentElement.classList.remove('bis-modal-open');
    current = null;
    var target = returnFocus;
    returnFocus = null;
    if (target && typeof target.focus === 'function' && document.contains(target)) {
      try { target.focus(); } catch (e) {}
    }
  }

  function showDone(text) {
    ui.form.hidden = true;
    ui.done.hidden = false;
    ui.doneMsg.textContent = text;
    var btn = ui.done.querySelector('button');
    if (btn) btn.focus();
  }

  function emit(status) {
    try {
      document.dispatchEvent(new CustomEvent('bis:signup', {detail: {status: status, variantId: current && current.variantId}}));
    } catch (e) {}
  }

  function onSubmit(e) {
    e.preventDefault();
    if (busy || !current) return;
    var info = current;
    var email = ui.email.value.trim();
    if (!validEmail(email)) {
      ui.email.setAttribute('aria-invalid', 'true');
      setMessage(INVALID_EMAIL, 'error');
      ui.email.focus();
      return;
    }
    ui.email.removeAttribute('aria-invalid');
    busy = true;
    ui.submit.disabled = true;
    setMessage('Signing you up…');

    Promise.all([resolveProductId(info), waitForToken()]).then(function (r) {
      var productId = r[0];
      if (!productId) throw new Error('no product id');
      var payload = {
        email: email,
        variant_id: info.variantId,
        product_id: productId,
        accepts_marketing: ui.marketing.checked,
        website: ui.website.value,
        language: (document.documentElement.getAttribute('lang') || '').slice(0, 16)
      };
      if (r[1]) payload['cf-turnstile-response'] = r[1];
      return fetch(signupUrl(), {
        method: 'POST',
        mode: 'cors',
        credentials: 'omit',
        headers: {'Content-Type': 'application/json', Accept: 'application/json'},
        body: JSON.stringify(payload)
      }).then(function (res) {
        return res.json().catch(function () { return {}; }).then(function (body) { return {res: res, body: body || {}}; });
      });
    }).then(function (out) {
      if (current !== info) return;
      var body = out.body;
      var message = typeof body.message === 'string' && body.message ? body.message : '';
      if (out.res.ok && body.ok) {
        var status = body.status || 'created';
        emit(status);
        showDone(message || "You're on the list. We'll email you as soon as it's available.");
        return;
      }
      emit('error');
      if (body.error === 'invalid_email') ui.email.setAttribute('aria-invalid', 'true');
      setMessage(message || GENERIC_ERROR, 'error');
    }).catch(function () {
      if (current !== info) return;
      emit('error');
      setMessage(GENERIC_ERROR, 'error');
    }).then(function () {
      busy = false;
      if (ui) ui.submit.disabled = false;
      resetTurnstile();
    });
  }

  // ---- binding -----------------------------------------------------------

  function onClick(e) {
    var el = triggerFrom(e.target);
    if (!el) return;
    var info = readTrigger(el);
    if (!info.variantId) return;
    // Ours from here: no AMP popup, no anchor jump, no other handler.
    e.preventDefault();
    e.stopPropagation();
    if (el.hasAttribute('data-bis-hidden')) return;
    open(info);
  }

  window.addEventListener('click', onClick, true);

  window.SeelbachsBIS = {
    open: function (opts) {
      opts = opts || {};
      return open({el: opts.el || null, variantId: idOf(opts.variantId), productId: idOf(opts.productId), handle: opts.handle || ''});
    },
    close: close
  };
})();
